module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-ko-KR.23303298.jpg";